import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { 
  FaPhoneAlt, 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaWhatsapp,
  FaClock,
  FaUser,
  FaComment,
  FaPaperPlane,
  FaCheckCircle,
  FaShieldAlt,
  FaHeadset,
  FaGlobe,
  FaBuilding,
  FaStar,
  FaArrowRight
} from "react-icons/fa";
import "../styles/ContactUs.css";
import Navbar from "../component/Navbar";
import Footer from "../component/Footer";

// Import images for fading hero background
import heroBg1 from "../assets/n1.png";
import heroBg2 from "../assets/n2.png";
import heroBg3 from "../assets/n3.png";
import officeImg from "../assets/dite.jpg";
import mapImg from "../assets/dite.jpg";

const ContactUs = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const heroSlides = [
    { image: heroBg1, title: "24/7 Support", subtitle: "Always here to help" },
    { image: heroBg2, title: "Expert Assistance", subtitle: "Professional guidance" },
    { image: heroBg3, title: "Quick Response", subtitle: "Within 30 minutes" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [heroSlides.length]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setFormData({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
      });
      setTimeout(() => setIsSubmitted(false), 5000);
    }, 1500);
  };

  const contactInfo = [
    {
      icon: <FaPhoneAlt />,
      title: "Phone Number",
      details: ["+91 7428203483"],
      link: "tel:+917428203483",
      color: "#3b82f6",
      bg: "rgba(59, 130, 246, 0.1)"
    },
    {
      icon: <FaWhatsapp />,
      title: "WhatsApp",
      details: ["+91 7428203483"],
      link: "https://wa.me/917428203483",
      color: "#25D366",
      bg: "rgba(37, 211, 102, 0.1)"
    },
    {
      icon: <FaEnvelope />,
      title: "Email Address",
      details: ["indiandetective23@gmail.com", "support@indian-detective.com"],
      link: "mailto:indiandetective23@gmail.com",
      color: "#ef4444",
      bg: "rgba(239, 68, 68, 0.1)"
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Office Address",
      details: ["H.NO-118, Rohini,", "North West Delhi - 110042"],
      link: "https://maps.google.com/?q=Rohini+Delhi",
      color: "#f59e0b",
      bg: "rgba(245, 158, 11, 0.1)"
    }
  ];

  const officeHours = [
    { day: "Monday - Friday", hours: "9:00 AM - 8:00 PM", isOpen: true },
    { day: "Saturday", hours: "10:00 AM - 6:00 PM", isOpen: true },
    { day: "Sunday", hours: "Emergency Only", isOpen: true }
  ];

  const stats = [
    { number: "5000+", label: "Happy Clients", icon: <FaStar /> },
    { number: "98%", label: "Satisfaction Rate", icon: <FaCheckCircle /> },
    { number: "24/7", label: "Emergency Support", icon: <FaHeadset /> },
    { number: "50+", label: "Expert Detectives", icon: <FaShieldAlt /> }
  ];

  return (
    <>
      <Navbar />
      <div className="contact-us-page">
        {/* Animated Background */}
        <div className="contact-bg">
          <div className="contact-orb-1"></div>
          <div className="contact-orb-2"></div>
          <div className="contact-orb-3"></div>
        </div>

        {/* Hero Section with Fading Background */}
        <section className="contact-hero">
          {/* Fading Background Images */}
          <div className="contact-hero-bg">
            {heroSlides.map((slide, index) => (
              <div
                key={index}
                className={`contact-hero-slide ${index === currentSlide ? "active" : ""}`}
                style={{ backgroundImage: `url(${slide.image})` }}
              >
                <div className="contact-hero-overlay"></div>
              </div>
            ))}
            <div className="contact-hero-gradient"></div>
          </div>

          {/* Hero Content */}
          <div className="contact-hero-content">
            <div className="hero-badge">
              <FaHeadset />
              <span>24/7 Support Available</span>
            </div>
            <h1 className="contact-hero-title">
              Get In <span className="title-glow">Touch</span>
            </h1>
            <p className="contact-hero-subtitle">
              Have questions or need assistance? Our team of experts is here to help you 
              24/7. Reach out to us for a free, no-obligation consultation.
            </p>
            <div className="contact-hero-stats">
              {stats.map((stat, index) => (
                <div key={index} className="hero-stat">
                  <div className="hero-stat-icon">{stat.icon}</div>
                  <div>
                    <div className="hero-stat-number">{stat.number}</div>
                    <div className="hero-stat-label">{stat.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Dots Navigation */}
          <div className="contact-hero-dots">
            {heroSlides.map((_, index) => (
              <button
                key={index}
                className={`contact-hero-dot ${index === currentSlide ? "active" : ""}`}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div>
        </section>

        {/* Contact Info Cards */}
        <section className="contact-info-section">
          <div className="container-contact">
            <div className="contact-info-grid">
              {contactInfo.map((info, index) => (
                <a 
                  key={index} 
                  href={info.link} 
                  target={info.title === "Office Address" ? "_blank" : "_self"}
                  rel="noopener noreferrer"
                  className="contact-info-card"
                  style={{ backgroundColor: info.bg, borderColor: `${info.color}30` }}
                >
                  <div className="info-icon" style={{ color: info.color }}>
                    {info.icon}
                  </div>
                  <h3>{info.title}</h3>
                  {info.details.map((detail, i) => (
                    <p key={i}>{detail}</p>
                  ))}
                  <span className="info-link" style={{ color: info.color }}>
                    Connect <FaArrowRight />
                  </span>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Form & Map Section */}
        <section className="contact-form-section">
          <div className="container-contact">
            <div className="form-map-grid">
              {/* Contact Form */}
              <div className="contact-form-wrapper">
                <div className="form-header">
                  <span className="form-badge">Send us a Message</span>
                  <h2>Let's Start a <span className="gradient-text">Conversation</span></h2>
                  <p>Fill out the form below and our team will get back to you within 24 hours.</p>
                </div>

                {isSubmitted && (
                  <div className="success-message">
                    <FaCheckCircle />
                    <div>
                      <h4>Message Sent Successfully!</h4>
                      <p>Thank you for contacting us. We'll get back to you shortly.</p>
                    </div>
                  </div>
                )}

                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-row">
                    <div className="form-group">
                      <label>
                        <FaUser />
                        Your Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        placeholder="Enter your full name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>
                        <FaEnvelope />
                        Email Address
                      </label>
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>
                        <FaPhoneAlt />
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        placeholder="Enter your phone number"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>
                        <FaComment />
                        Subject
                      </label>
                      <input
                        type="text"
                        name="subject"
                        placeholder="What is this regarding?"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group full-width">
                    <label>
                      <FaComment />
                      Your Message
                    </label>
                    <textarea
                      name="message"
                      rows="5"
                      placeholder="Tell us about your investigation needs..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>

                  <button 
                    type="submit" 
                    className="submit-btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>Sending... <div className="spinner"></div></>
                    ) : (
                      <>Send Message <FaPaperPlane /></>
                    )}
                  </button>
                </form>

                <div className="form-footer">
                  <p>By submitting this form, you agree to our <Link to="/privacy-policy">Privacy Policy</Link></p>
                </div>
              </div>

              {/* Office Hours & Location */}
              <div className="info-wrapper">
                {/* Office Hours */}
                <div className="office-hours-card">
                  <div className="hours-header">
                    <FaClock />
                    <h3>Office Hours</h3>
                  </div>
                  <div className="hours-list">
                    {officeHours.map((item, index) => (
                      <div key={index} className="hour-item">
                        <span className="day">{item.day}</span>
                        <span className="hours">{item.hours}</span>
                        <span className="status-badge available">Available</span>
                      </div>
                    ))}
                  </div>
                  <div className="emergency-note">
                    <FaHeadset />
                    <span>Emergency? Call us anytime 24/7</span>
                    <a href="tel:+917428203483" className="emergency-call">Call Now</a>
                  </div>
                </div>

                {/* Map */}
                <div className="map-card">
                  <h3>Find Us Here</h3>
                  <div className="map-container">
                    <img src={mapImg} alt="Office Location" />
                    <div className="map-overlay">
                      <div className="location-pin">
                        <FaMapMarkerAlt />
                        <span>Indian-Detective Agency</span>
                      </div>
                    </div>
                  </div>
                  <a 
                    href="https://maps.google.com/?q=Rohini+Delhi" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="get-directions"
                  >
                    Get Directions <FaArrowRight />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Contact Us Section */}
        <section className="why-contact-section">
          <div className="container-contact">
            <div className="why-contact-header">
              <span className="section-badge">Why Contact Us</span>
              <h2>Why Choose <span className="gradient-text">Indian-Detective Agency?</span></h2>
            </div>
            <div className="why-contact-grid">
              <div className="why-card">
                <div className="why-icon">🔒</div>
                <h3>100% Confidential</h3>
                <p>Your privacy is our priority. All communications are strictly confidential.</p>
              </div>
              <div className="why-card">
                <div className="why-icon">⚡</div>
                <h3>Quick Response</h3>
                <p>We respond to all inquiries within 30 minutes during business hours.</p>
              </div>
              <div className="why-card">
                <div className="why-icon">🎯</div>
                <h3>Expert Guidance</h3>
                <p>Get free consultation from experienced investigation professionals.</p>
              </div>
              <div className="why-card">
                <div className="why-icon">🌍</div>
                <h3>Pan India Service</h3>
                <p>We provide investigation services across all major cities in India.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Emergency CTA */}
        <section className="emergency-cta">
          <div className="container-contact">
            <div className="emergency-card">
              <div className="emergency-content">
                <div className="emergency-icon">🚨</div>
                <h2>Need Urgent Assistance?</h2>
                <p>For emergency cases, call our 24/7 helpline for immediate assistance.</p>
                <div className="emergency-buttons">
                  <a href="tel:+917428203483" className="emergency-btn call">
                    <FaPhoneAlt /> Call Now: +91 7428203483
                  </a>
                  <a href="https://wa.me/917428203483" className="emergency-btn whatsapp" target="_blank" rel="noopener noreferrer">
                    <FaWhatsapp /> WhatsApp Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;